declare module '*.module.scss' {
  const content: Record<string, string>;
  export default content;
}

declare module '*.scss';
